import { Skeleton } from 'antd';

import {
  ProfileWrapper,
  ImageContainer,
  ProfileInfoContainer,
  TopHeader,
  MidleHeader,
  BottomHeader,
} from './guest.styled';

export default function ProfileSkeleton() {
  return (
    <ProfileWrapper>
      <ImageContainer>
        <Skeleton.Avatar size={150} active />
      </ImageContainer>

      <ProfileInfoContainer>
        <TopHeader>
          <Skeleton.Input active style={{ width: 100, height: 30 }} />
          <Skeleton.Input
            active
            style={{ width: 70, height: 24 }}
            className="username"
          />
          <Skeleton.Input active style={{ width: 70, height: 26 }} />
        </TopHeader>

        <MidleHeader>
          <Skeleton.Input
            active
            style={{ width: 80, height: 22, marginTop: 6 }}
          />
        </MidleHeader>

        <BottomHeader>
          <Skeleton.Input
            active
            style={{ width: 60, height: 22, marginTop: 6 }}
          />
          <Skeleton.Input
            active
            style={{ width: 60, height: 22, marginTop: 6 }}
          />
        </BottomHeader>
      </ProfileInfoContainer>
    </ProfileWrapper>
  );
}
